module.exports = __webpack_public_path__ + "img/Ardunic Elements-07.31944140.svg";